/**
 * Extracts the UUID from an API Platform IRI string.
 * e.g. "/dashboard-templates/abc-123" → "abc-123"
 */
export function extractIdFromIri(iri: string): string {
  const segments = iri.split('/')
  return segments[segments.length - 1] ?? iri
}
